import PropTypes from "prop-types"
import React from "react"
import {Dimmer, Grid, Loader} from "semantic-ui-react"
import DetailsRefundTableContainer from "../../components/DetailsRefundTable/detailsRefundTableContainer"
import RapidSearchFormContainer from "../../components/RapidSearchForm/rapidSearchFormContainer"
import PaginationContainer from "../../shared-components/components/Pagination/paginationContainer"
import {TableActionColor} from "../../shared-components/components/Table/tableActionColors"
import TableContainer from "../../shared-components/components/Table/tableContainer"
import {Entity, EntityInfo} from "../../shared-components/constants/entities"
import {useTexts} from "../../shared-components/hooks/useTexts"
import {getEntity} from "../../store/selectors/entities/entitiesSelectors"
import {getActivePage, getMaxPage} from "../../store/selectors/temporaries/paginationSelectors"
import * as tableSelectors from "../../store/selectors/temporaries/tableSelectors"
import "./historyRefund.scss"

const HistoryRefundScene = ({
    changePage,
    closeDetailsRefundBox,
    detailsRefundId,
    downloadSlipRefundFile,
    isDetailsOpen,
    isFetchingHandoverPdf,
    isFetchingRefundRetrieve,
    onSubmit,
    openDetailsRefundBox,
    refundChannelSelectValues,
    refundTrackSelectValues,
    sortColumnFunction,
    totalResults,
}) => {
    const texts = useTexts()
    return (
        <div className="history-refund-scene">
            <Grid centered>
                <Grid.Column only="computer" width={1} />
                <Grid.Column width={14}>
                    <div className="history-refund-scene-paragraph">{texts.historyRefundTitle}</div>
                    <div className="history-refund-scene-rapid-search">
                        <RapidSearchFormContainer
                            isFetching={isFetchingRefundRetrieve}
                            numberPlaceholder="N° remise"
                            onSubmit={onSubmit}
                            refundChannelSelectValues={refundChannelSelectValues}
                            refundTrackSelectValues={refundTrackSelectValues}
                        />
                    </div>
                    <Dimmer.Dimmable className="main-infos-form-panels">
                        <Dimmer active={isFetchingHandoverPdf} inverted>
                            <Loader active={isFetchingHandoverPdf} />
                        </Dimmer>
                        <TableContainer
                            columns={[
                                {type: "TEXT", name: "Date de remise", accessor: "refundDate"},
                                {type: "TEXT", name: "Numéro de remise", accessor: "refundNumber"},
                                {type: "TEXT", name: "Circuit", accessor: "track"},
                                {type: "TEXT", name: "Acheminement", accessor: "channel"},
                                {type: "TEXT", name: "Nombre de titre", accessor: "titleCount"},
                                {type: "TEXT", name: "Montal Total (€)", accessor: "totalAmount"},
                                {type: "TEXT", name: "Date virement prévue", accessor: "refundPayment"},
                                {type: "TEXT", name: "Statut", accessor: "refundState"},
                                {
                                    type: "ACTION",
                                    name: "Actions",
                                    actions: [
                                        {
                                            action: (tableName, id) => openDetailsRefundBox(id),
                                            faIcon: "eye",
                                            popup: "Voir les détails",
                                            color: TableActionColor.PRIMARY,
                                        },
                                        {
                                            action: (tableName, id) => downloadSlipRefundFile(id),
                                            faIcon: "file pdf",
                                            popup: "Télécharger le bordereau de remise",
                                            color: TableActionColor.PRIMARY,
                                            accessor: "isBillDownloadable",
                                        },
                                    ],
                                },
                            ]}
                            entityHelperFunction={(state, id) => getEntity(state, EntityInfo[Entity.REFUNDS].name, id)}
                            name="historyRefundTable"
                            sortColumnFunction={sortColumnFunction}
                            sortable
                            {...tableSelectors}
                        />
                    </Dimmer.Dimmable>
                    <div className="history-refund-scene-pagination">
                        <div className="history-refund-scene-pagination-info anchor-refund-details">
                            {isFetchingRefundRetrieve && <Loader active inline />}
                            {!isFetchingRefundRetrieve && totalResults !== 0 && (
                                <span>{totalResults} résultat(s). </span>
                            )}
                            {!isFetchingRefundRetrieve && totalResults === 0 && <span>Pas de résultats. </span>}
                        </div>
                        <PaginationContainer
                            componentName="historyRefundTablePagination"
                            getActivePage={getActivePage}
                            getMaxPage={getMaxPage}
                            onPaginationClick={changePage}
                        />
                    </div>

                    {detailsRefundId && isDetailsOpen && (
                        <div className="history-refund-scene-details-refund">
                            <DetailsRefundTableContainer
                                closeDetailsRefundBox={closeDetailsRefundBox}
                                detailsRefundId={detailsRefundId}
                            />
                        </div>
                    )}
                </Grid.Column>
                <Grid.Column only="computer" width={1} />
            </Grid>
        </div>
    )
}

HistoryRefundScene.propsTypes = {
    changePage: PropTypes.func.isRequired,
    closeDetailsRefundBox: PropTypes.func.isRequired,
    detailsRefundId: PropTypes.number.isRequired,
    downloadSlipRefundFile: PropTypes.func.isRequired,
    isDetailsOpen: PropTypes.func.isRequired,
    isFetchingHandoverPdf: PropTypes.bool.isRequired,
    isFetchingRefundRetrieve: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    openDetailsRefundBox: PropTypes.func.isRequired,
    refundChannelSelectValues: PropTypes.array.isRequired,
    refundTrackSelectValues: PropTypes.array.isRequired,
    sortColumnFunction: PropTypes.func.isRequired,
    totalResults: PropTypes.number.isRequired,
}

export default HistoryRefundScene
